import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import './Kinderverwaltung.css';
import '../../styles/CiTable.css';

function Kinderverwaltung() {
  const [zelte, setZelte] = useState([]);
  const [kinder, setKinder] = useState([]);
  const [einheiten, setEinheiten] = useState([]);
  const [selectedZelt, setSelectedZelt] = useState('');
  const [selectedKind, setSelectedKind] = useState('');
  const [verfuegbarkeit, setVerfuegbarkeit] = useState({});
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    fetch(`${host_url}/zelte`)
      .then(response => response.json())
      .then(data => setZelte(data));
  }, []);

  useEffect(() => {
    if (selectedZelt) {
      fetch(`${host_url}/kinder?zeltId=${selectedZelt}`)
        .then(response => response.json())
        .then(data => setKinder(data));
    }
  }, [selectedZelt]);

  useEffect(() => {
    if (selectedKind) {
      fetch(`${host_url}/einheiten`)
        .then(response => response.json())
        .then(data => setEinheiten(data));

      fetch(`${host_url}/kinderverfuegbarkeit?kindId=${selectedKind}`)
        .then(response => response.json())
        .then(data => {
          const verfuegbarkeitMap = {};
          data.forEach(item => {
            verfuegbarkeitMap[item.EinheitenID] = item.Verfuegbar === 1;
          });
          setVerfuegbarkeit(verfuegbarkeitMap);
        });
    }
  }, [selectedKind]);

  const handleVerfuegbarkeitChange = (einheitId) => {
    setVerfuegbarkeit(prev => ({
      ...prev,
      [einheitId]: !prev[einheitId]
    }));
  };

  const handleSubmit = () => {
    const requests = einheiten.map(einheit => ({
      KindID: selectedKind,
      EinheitenID: einheit.ID,
      Verfuegbar: verfuegbarkeit[einheit.ID] ? 1 : 0
    }));

    fetch(`${host_url}/kinderverfuegbarkeit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requests)
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setSuccessMsg('Verfügbarkeit erfolgreich aktualisiert');
      } else {
        alert('Fehler beim Aktualisieren der Verfügbarkeit');
      }
    });
  };

  return (
    <KernteamLayout>
    <div className="container">
    <BackArrow to="/kinder" />
    <h1 className="section-title kinder">Kinder verwalten</h1>
    <main>
      <div>
        <label>Zelt</label>
        <div className={`dropdown-wrapper ${selectedZelt ? 'filled' : ''}`}>
          <select value={selectedZelt} onChange={e => setSelectedZelt(e.target.value)}>
            <option value="" disabled>Wähle ein Zelt</option>
            {zelte.map(zelt => (
              <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>
            ))}
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
      </div>
      <div>
        <label>Kind</label>
        <div className={`dropdown-wrapper ${selectedKind ? 'filled' : ''}`}>
          <select
            value={selectedKind}
            onChange={e => setSelectedKind(e.target.value)}
            disabled={!selectedZelt}
          >
            <option value="" disabled>{selectedZelt ? 'Wähle ein Kind' : 'Wähle zuerst ein Zelt'}</option>
            {kinder.map(kind => (
              <option key={kind.KindID} value={kind.KindID}>{kind.Name}</option>
            ))}
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
      </div>
      <div className="ci-table-wrapper">
      <table className="ci-table">
        <thead>
          <tr>
            <th>Einheit</th>
            <th>Verfügbar</th>
          </tr>
        </thead>
        <tbody>
          {einheiten.map(einheit => (
            <tr key={einheit.ID}>
              <td>{einheit.Name}</td>
              <td>
                <input
                  type="checkbox"
                  checked={verfuegbarkeit[einheit.ID] || false}
                  onChange={() => handleVerfuegbarkeitChange(einheit.ID)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <button onClick={handleSubmit}>Änderungen absenden</button>
    </main>
    </div>
    <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default Kinderverwaltung;
